import React from 'react'
import {
    TudoAli,
    PodRef,
    PodFreeBalance,
    PodAux,
    PodAliRef,
    PodAuxHealth,
    PodAuxPharmacy,
    PodAuxEntertainment,
    PodAuxHomeoffice,
    PodAuxEducation,
    PodAuxFuel,
    PodAuxBus,
    PodAuxMobility
} from 'assets/img/card-icons'

export const groups = {
    ALIMENTACAO_REFEICAO: 'ALIMENTACAO_REFEICAO',
    OUTROS: 'OUTROS'
}

export const aleloPodGroups = [
    {
        desc: 'Alimentação',
        type: 'ALIMENTACAO',
        code: 6,
        baseType: 'POD',
        isPat: [true],
        taxName: 'Tarifa de alimentação',
        tooltipDesc: (
            <>
                Benefício utilizado para a
                <br /> compra de alimentos em
                <br /> ampla rede credenciada de
                <br /> supermercados, açougues,
                <br /> quitandas e similares.
            </>
        ),
        icon: TudoAli,
        order: 0,
        feeType: 'PERCENTAGE'
    },
    {
        desc: 'Refeição',
        type: 'REFEICAO',
        code: 5,
        baseType: 'POD',
        isPat: [true],
        taxName: 'Taxa de administração refeição',
        tooltipDesc: (
            <>
                Benefício voltado ao
                <br /> pagamento das refeições em
                <br /> ampla rede credenciada, que
                <br /> inclui restaurantes,
                <br /> lanchonetes e similares.
            </>
        ),
        icon: PodRef,
        order: 1,
        feeType: 'PERCENTAGE'
    },
    {
        desc: 'Alimentação e Refeição',
        type: 'ALIMENTACAO_REFEICAO',
        code: [7, 8],
        baseType: 'POD',
        isPat: [false],
        taxName: 'Taxa de administração auxílio alimentação e refeição',
        tooltipDesc: (
            <>
                Cartão-benefício voltado ao
                <br /> pagamento das refeições em
                <br /> ampla rede credenciada, que
                <br /> inclui restaurantes,
                <br /> lanchonetes e similares.
            </>
        ),
        icon: PodAliRef,
        order: 2,
        feeType: 'PERCENTAGE'
    },
    {
        desc: 'Outros Auxílios',
        type: 'OUTROS',
        code: 9,
        baseType: 'POD',
        isPat: [true, false],
        taxName: 'Taxa de administração outros auxílios',
        tooltipDesc: (
            <>
                Cartão-benefício voltado ao
                <br /> pagamento das refeições em
                <br /> ampla rede credenciada, que
                <br /> inclui restaurantes,
                <br /> lanchonetes e similares.
            </>
        ),
        icon: PodAux,
        order: 3,
        feeType: 'PERCENTAGE'
    },
    {
        desc: 'Saldo Livre',
        type: 'SALDO_LIVRE',
        code: 10,
        baseType: 'POD',
        isPat: [true, false],
        taxName: 'Taxa de administração saldo livre',
        tooltipDesc: (
            <>
                Essa modalidade <b>permite fazer</b> <br />
                transferência de valores <b>para as contas</b> <br />
                Home Office, Mobilidade, Combustível, <br />
                Farmácia, Saúde & Bem-estar e Educação <br />
                (“Demais Benefícios”).
            </>
        ),
        icon: PodFreeBalance,
        order: 4,
        feeType: 'PERCENTAGE'
    }
]

export const others = [
    {
        icon: PodAuxHealth,
        title: 'Saúde e Bem-estar'
    },
    {
        icon: PodAuxPharmacy,
        title: 'Farmácia'
    },
    {
        icon: PodAuxMobility,
        title: 'Mobilidade'
    },
    {
        icon: PodAuxBus,
        title: 'Transporte Urbano'
    },
    {
        icon: PodAuxFuel,
        title: 'Combustível'
    },
    {
        icon: PodAuxEducation,
        title: 'Educação'
    },
    {
        icon: PodAuxHomeoffice,
        title: 'Home Office'
    },
    {
        icon: PodAuxEntertainment,
        title: 'Entretenimento'
    }
]
